<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';
    import DataTable from '../../DataGrid/DataTable.svelte';
    import TaskListConfigurationDataTable from '../../DataGrid/TaskListConfigurationDataTable.svelte';
    import OperationsColumn from './OperationsColumn.svelte'
    import UserDefinedOperationColumn from './UserDefinedOperationColumn.svelte'
    import AssignOperationsActionColumn from './AssignOperationsActionColumn.svelte'

    import Button from '../../Button.svelte';
    import Modal from '../../Modal.svelte';
    import TextInput from '../../TextInput.svelte';
    import TextColumn from '../../DataGrid/ColumnRenderers/TextColumn.svelte';
    import SelectColumn from '../../DataGrid/ColumnRenderers/SelectColumn.svelte';

    import {get} from '../../../utils.js';
    import {submit} from '../../Form/utils.js';
    import {validateForm} from '../../Form/utils.js';
    import {sgettext} from '../../../i18n.js';
    import yup, {array, object, string, number} from 'yup';
    import Errors from '../../Errors.svelte';

    export let rows = [];

    let data;
    $: data = rows.map(r => ({...r, fieldValidations: initialFieldValidations()}));
    $: for (let row of data) {
        if (row.unmapped_sequences > 0) {
            warnUnmappedSequences = true;
            break;
        } else {
            warnUnmappedSequences = false;
        }
    }

    export let template = true;
    export let activityVersionId = 0;
    export let planningPlant = null;
    export let timeZone = null;

    let listUrl = `${PATH_PREFIX}/sw/v2/api/task_lists/`;  // {% url internal-api:task-lists-list %}
    let taskListConfigUrl = `${PATH_PREFIX}/sw/v2/api/activity_version_activity_task_list_configurations/`; // {% url 'internal-v2:activity-version-activity-task-list-configurations-detail` pk %}
    let taskListSearchUrl = `${PATH_PREFIX}/sw/v2/api/gip-task-list-search/`; // {% url 'internal-v2:gip-task-list-search` %}

    let deleteModal = 'deleteTaskListModal';
    let overrideModal = 'operationOverrideModal';
    let configModal = 'taskListConfigModal';
    let userDefinedOperationsModal = 'userDefinedOperationsModal';

    let selectedItem = null;
    let taskListToAddUserDefinedOperationsTo = null;
    let selectedOperations = [];
    let deleting = false;
    let disableSave = false;
    let errors = null;
    let formErrors = null;
    let saveConfigFormErrors = null;

    let userDefinedOperationsErrors = null;
    let bgColor = '#EDF1F2';
    let sending = false;
    let warnUnmappedSequences = false;

    let availableOperations = [];
    let existingMappingsForAvailableOperationsInOtherActivities = {};
    $: if (selectedItem !== null && selectedItem.operations_in_other_activities) {
        existingMappingsForAvailableOperationsInOtherActivities = selectedItem.operations_in_other_activities.reduce(function (obj, x) {
            if (x.activity_version.id !== activityVersionId) {
                obj[x.operation.id] = x;
            }
            return obj;
        }, {});
    }

    let existingMappingsForAvailableOperationsInOtherTaskListsForThisActivity = {};
    $: if (selectedItem !== null && selectedItem.operations_in_other_task_lists) {
        existingMappingsForAvailableOperationsInOtherTaskListsForThisActivity = selectedItem.operations_in_other_task_lists.reduce(function (obj, x) {
            if (x.activity_version.id === activityVersionId) {
                obj[x.operation.id] = x;
            }
            return obj;
        }, {});
    }

    let userDefinedOperations = [];

    let showSplitTaskListMessage = false;
    $: showSplitTaskListMessage = availableOperations.length > 1 && selectedOperations.length < availableOperations.length;
    $: showSaveAndNewButton = selectedOperations.length !== availableOperations.filter(operation => !existingMappingsForAvailableOperationsInOtherTaskListsForThisActivity[operation.id] && !existingMappingsForAvailableOperationsInOtherActivities[operation.id]).length;

    let config = createNewItem();
    let sendingConfiguration = false;
    let sendingSearch = false;
    let searchStatus = '';
    let taskList = {};
    let saving = false;
    let searchDisabled = true;
    let saveConfigDisabled = true;

    let selectedOverrides = [];
    let overridesSelectedForRemoval = [];

    $: operationOptionsData = availableOperations.filter(r => !r.user_defined && !r.deleted && selectedOperations.includes(r.id)).map(r => ({id: r.id, name: r.number, description: r.description, fieldValidations: getDefaultFieldIsValid()}));
    $: userDefinedOperationsData = userDefinedOperations.map((r, index) => ({...r, index: index, fieldValidations: getDefaultUserDefinedOperationFieldIsValid()}));

    $: selectedOverridesData = selectedOverrides.filter(r => !r.operation?.user_defined && !r.operation?.deleted)
    .map((r, index) => ({
        ...r,
        operation_id: r.operation_id ? r.operation_id : r.operation?.id,
        index: index,
        fieldValidations: getDefaultFieldIsValid()
    }));

    $: searchDisabled = !config.group_counter || !config.group || sendingSearch;
    $: saveConfigDisabled = availableOperations && availableOperations.length === 0 || selectedOperations && selectedOperations.length === 0 || disableSave;

    const schema = yup.object().shape({});

    let rowSchema = object().shape({
        operation_id: string()
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .typeError(sgettext('$$REQUIRED_FIELD$$')),
        override_operation: string()
            .matches(/^[0-9]{4}$/, sgettext('$$FIELD_REQUIRED_4_DIGITS$$'))
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .typeError(sgettext('$$FIELD_REQUIRED_NUMERIC$$')),
    });

    let userDefinedRowSchema = object().shape({
        number: string()
            .matches(/^[0-9]{4}$/, '$$FIELD_REQUIRED_4_DIGITS$$')
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .typeError(sgettext('$$FIELD_REQUIRED_NUMERIC$$')),
    });


    let duplicateOperationError = sgettext('$$ONE_ROWS_CONTAIN_DUPLICATE_OPERATIONS$$');

    function getDefault() {
        return {
            override_operation: '',
            id: null,
            operation_id: null,
            expire: false,
            existing: false,
        };
    }

    function getDefaultUserDefinedOperation() {
        return {
            id: crypto.randomUUID(),
            number: '',
            deleted: false,
        };
    }

    function getDefaultFieldIsValid() {
        return {
            operation_id: {
                isValid: true,
                errors: '',
            },
            override_operation: {
                isValid: true,
                errors: '',
            },
        };
    }

    function getDefaultUserDefinedOperationFieldIsValid() {
        return {
            number: {
                isValid: true,
                errors: '',
            },
            deleted: {
                isValid: true,
                errors: '',
            }
        };
    }

    async function handleCreateNewOverride() {
        selectedOverrides = [...selectedOverridesData, {...getDefault(), index: selectedOverridesData.length}];
    }

    async function handleCreateNewUserDefinedOperation() {
        userDefinedOperations = [...userDefinedOperationsData, getDefaultUserDefinedOperation()]
    }

    let columns = {
        group: {
            label: sgettext('$$GROUP_NUMBER$$')
        },
        group_counter: {
            label: sgettext('$$GROUP_COUNTER$$')
        },
        plant: {
            label: sgettext('$$PLANT$$')
        },
        description: {  // alias for name
            label: sgettext('$$TL_CONFIG_DESCRIPTION$$')
        },
        operations: {
            label: sgettext('$$OPERATIONS$$'),
            renderer: OperationsColumn
        }
    }

    let rowActions = null;

    if (template) {
        rowActions = {
            edit: {
                label: sgettext('$$EDIT$$'),
                iconClass: 'fas fa5-pencil-alt fa-fw',
                handler: (event, item) => {
                    selectedItem = item;
                    handleEditItem(item);
                }
            },
            assign_operations: {
                label: sgettext('$$MAP_OPERATIONS$$'),
                iconClass: 'fas fa5-pencil fa-fw',
                renderer: AssignOperationsActionColumn,
            },
            set_override: {
                label: sgettext('$$OPERATION_OVERRIDES$$'),
                iconClass: 'fas fa5-undo fa-fw',
                handler: (event, item) => {
                    selectedItem = item;
                    handleOperationOverride(item);
                }
            },
            user_defined: {
                label: sgettext('$$USERDEFINED_OPERATIONS$$'),
                iconClass: 'fas fa5-user-plus fa-fw',
                handler: (event, item) => {
                    selectedItem = item;
                    handleUserDefinedOperations(item);
                }
            },

            remove: {
                label: sgettext('$$EXPIRE$$'),
                iconClass: 'fas fa5-trash fa-fw',
                handler: (event, item) => {
                    selectedItem = item;
                    handleDeleteConfirmation(item);
                }
            }
        }
    }

    function initialFieldValidations() {
        return {
            name: {
                isValid: true,
                errors: '',
            },
            group: {
                isValid: true,
                errors: '',
            },
            group_counter: {
                isValid: true,
                errors: '',
            },
            operations: {
                isValid: true,
                errors: '',
            }
        };
    }

    let fieldIsValid = initialFieldValidations();


    async function getTaskList(taskListId) {
        const response = await get(`${listUrl}?id=${taskListId}`);
        let responseJson = await response.json();
        selectedOperations = [...config.operations.map(x => x.id)];
        taskList = responseJson.results[0];
        availableOperations = [...taskList.operations];
        config.group = taskList.group;
        config.group_counter = taskList.group_counter;
        selectedItem = {...config};
        // Need to calculate these now instead of relying on reactivity to make sure the options are
        // correctly greyed out.
        existingMappingsForAvailableOperationsInOtherTaskListsForThisActivity = taskList.operations_in_other_activities.reduce(function (obj, x) {
            if (x.activity_version.id === activityVersionId) {
                obj[x.operation.id] = x;
            }
            return obj;
        }, {});

        existingMappingsForAvailableOperationsInOtherActivities = taskList.operations_in_other_activities.reduce(function (obj, x) {
            if (x.activity_version.id !== activityVersionId) {
                obj[x.operation.id] = x;
            }
            return obj;
        }, {});
    }

    async function handleEditItem(item) {
        jQuery(`#${configModal}`).modal('show');
        config = {...item};
        await getTaskList(item.activity_task_list.task_list);
    }

    async function handleOperationOverride(item) {
        jQuery(`#${overrideModal}`).modal('show');
        config = {...item};
        await getTaskList(item.activity_task_list.task_list);
        selectedOverrides = selectedItem.override_operations.filter(({ override_operation }) => override_operation)
        .map(({id, operation, override_operation}) => {
            const operationObj = availableOperations.find((op) => op.id === operation);
            const {number: name, description} = operationObj ?? {};
            return {id, operation, name, description, override_operation, expire:false, existing:true};
        });
    }

    async function handleUserDefinedOperations(item) {
        jQuery(`#${userDefinedOperationsModal}`).modal('show');
        userDefinedOperations = [...item.activity_task_list.tl.operations.filter(x => x.user_defined && !x.deleted)];
        taskListToAddUserDefinedOperationsTo = item;
        await getTaskList(item.activity_task_list.task_list);
    }


    async function overrideOnSaveAndClose() {
        let validateIndex = 0;
        let overrideIds = new Set();
        try {
            for (let row of selectedOverridesData) {
                await validateForm(rowSchema, row);
                if (overrideIds.has(row.operation_id)) {
                    throw new Error(duplicateOperationError);
                }
                overrideIds.add(row.operation_id);
                validateIndex++;
            }

            await validateForm(array(), selectedOverridesData);
            await handleSaveConfig(false);

            if (!formErrors || formErrors.length === 0) {
                jQuery(`#${overrideModal}`).modal('hide');
                resetOverrideForm();
            }
        } catch (err) {
            if (err.inner) {
                err.inner.forEach((er) => {
                    selectedOverridesData[validateIndex].fieldValidations[er.path].isValid = false;
                    selectedOverridesData[validateIndex].fieldValidations[er.path].errors = er.message;
                });
            } else if (err.message === duplicateOperationError){
                selectedOverridesData[validateIndex].fieldValidations.operation_id.isValid = false;
                selectedOverridesData[validateIndex].fieldValidations.operation_id.errors = err.message;
            }
        }
    }

    async function userDefinedOperationsOnSaveAndClose() {
        let validateIndex = 0;
        let userDefinedOperationNumbers = new Set();
        try {
            for (let row of userDefinedOperationsData) {
                if (!row.deleted) {
                    await validateForm(userDefinedRowSchema, row);
                    if (userDefinedOperationNumbers.has(row.number)) {
                        throw new Error(duplicateOperationError);
                    }
                    userDefinedOperationNumbers.add(row.number);
                }
                validateIndex++;
            }
        } catch (err) {
            if (err.inner) {
                err.inner.forEach((er) => {
                    userDefinedOperationsData[validateIndex].fieldValidations[er.path].isValid = false;
                    userDefinedOperationsData[validateIndex].fieldValidations[er.path].errors = er.message;
                });
            } else if (err.message === duplicateOperationError){
                userDefinedOperationsData[validateIndex].fieldValidations.number.isValid = false;
                userDefinedOperationsData[validateIndex].fieldValidations.number.errors = err.message;
            }
            return;
        }

        await handleSaveUserDefinedOperations(false);
        if (!userDefinedOperationsErrors || userDefinedOperationsErrors.length === 0) {
            jQuery(`#${userDefinedOperationsModal}`).modal('hide');
            resetUserDefinedOperationsForm();
        }
    }


    async function handleDeleteItem() {
        try {
            if (!deleting) {
                deleting = true;

                let url = `${taskListConfigUrl}${selectedItem.id}/`;
                let method = 'DELETE';
                await submit(url, method, {});
                rows = [...rows.filter(x => x.id !== selectedItem.id)]
                handleDeleteSaveAndClose();
                deleting = false;
            }
        } catch (err) {
            deleting = false;
        }

    }

    async function handleDeleteConfirmation(item) {
        jQuery(`#${deleteModal}`).modal('show');
    }

    function handleCancelDelete() {
        jQuery(`#${deleteModal}`).modal('hide');
        selectedItem = null;
    }

    function handleDeleteSaveAndClose() {
        handleCancelDelete();
        getConfigurations();
    }

    function handleCancelOverride() {
        jQuery(`#${overrideModal}`).modal('hide');
        resetOverrideForm();
    }

    async function handleCreateNew() {
        config.id = null;
        config.name = '';
        config.activity_task_list = null;
        resetFormValidation();
        handleSearchTaskList();
        jQuery(`#${configModal}`).modal('show');
    }

    function createNewItem() {
        return {
            id: null,
            activity_version: activityVersionId,
            activity_task_list: null,
            name: '',
            group: '',
            group_counter: '',
            operations: [],
            override_operations: [],
            fieldValidations: initialFieldValidations(),
        };
    }

    function resetFormValidation() {
        fieldIsValid = initialFieldValidations();
        errors = null;
    }

    function resetConfigForm() {
        config = createNewItem();
        saveConfigFormErrors = null;
        resetFormValidation();
    }

    function resetSearchForm() {
        searchStatus = '';
        availableOperations = [];
        selectedOperations = [];
        existingMappingsForAvailableOperationsInOtherTaskListsForThisActivity = {};
        existingMappingsForAvailableOperationsInOtherActivities = {};
        disableSave = false;
    }

    function resetOverrideForm() {
        availableOperations = [];
        selectedOverrides = [];
        overridesSelectedForRemoval = [];
        selectedOverridesData = selectedOverridesData.map(r => ({...r, fieldValidations: getDefaultFieldIsValid()}));
    }

    function clearFormErrors(){
        userDefinedOperationsErrors = null;
        formErrors = null;
        errors = null;
    }

    function resetUserDefinedOperationsForm() {
        userDefinedOperationsData = userDefinedOperationsData.map(r => ({...r, fieldValidations: getDefaultUserDefinedOperationFieldIsValid()}));
    }

    async function handleCancelConfig() {
        jQuery(`#${configModal}`).modal('hide');
        resetConfigForm();
        resetSearchForm();
        handleCancelOverride();
        clearFormErrors();
    }

    async function handleSaveAndClose() {
        handleCancelConfig();
        getConfigurations();
    }

    async function handleCancelUserDefinedOperations() {
        jQuery(`#${userDefinedOperationsModal}`).modal('hide');
        resetUserDefinedOperationsForm();
        clearFormErrors();
    }

    function handleSearchOnEnterKey(e) {

        if (!searchDisabled) {
            if (e.keyCode === 13) {
                handleSearchTaskList();
            }
        }

    }

    async function handleSearchTaskList() {

        if (!sendingSearch) {
            sendingSearch = true;
            resetSearchForm();

            try {
                const response = await get(`${taskListSearchUrl}?group=${config.group}&group_counter=${config.group_counter}&activity_version=${activityVersionId}&refresh_cache=0`);
                taskList = await response.json();

                if (Object.keys(taskList).length !== 0) {

                    existingMappingsForAvailableOperationsInOtherActivities = taskList['operations_in_other_activities'].reduce(function (obj, x) {
                        obj[x.operation.id] = x;
                        return obj;
                    }, {});

                    availableOperations = taskList['operations'];
                    let validOperations = availableOperations.filter(x => !(x.id in existingMappingsForAvailableOperationsInOtherActivities));
                    selectedOperations = validOperations.map(x => x.id);  // select all valid operations

                    if (availableOperations.length === 0) {
                        searchStatus = sgettext('$$TASK_LIST_OPERATIONS$$');
                        availableOperations = []
                    } else if (availableOperations.length === 1) {
                        searchStatus = sgettext('$$1_OPERATION_FOUND$$');
                    } else {
                        searchStatus = sgettext(`${availableOperations.length} operations found`);
                    }

                    disableSave = availableOperations.every((operation) => {
                        return existingMappingsForAvailableOperationsInOtherActivities[operation.id] !== undefined;
                    });

                } else {
                    availableOperations = [];
                    searchStatus = sgettext('$$RESULTS_FOUND$$');
                }
            } catch (err) {
                availableOperations = [];
                searchStatus = sgettext('$$RESULTS_FOUND_2$$');
            }


            sendingSearch = false;
        }

    }

    async function handleSaveUserDefinedOperations() {
        let taskListId = taskListToAddUserDefinedOperationsTo.activity_task_list.task_list;

        let url = `${PATH_PREFIX}/sw/v2/api/task_lists/${taskListId}/user-defined-operations/`;
        let payload = {
            operations: userDefinedOperationsData.filter(x => x.number !== '').map(x => ({number: x.number, deleted: x.deleted})),
            activity_version_activity_task_list_configuration: taskListToAddUserDefinedOperationsTo.id,
            activity_version_id: activityVersionId,
        };

        try {
            await submit(url, 'PUT', payload);
            jQuery(`#${userDefinedOperationsModal}`).modal('hide');
            await getConfigurations();
            await handleCancelUserDefinedOperations();
        } catch (err) {
            userDefinedOperationsErrors = err;
        }

    }

    function handleSaveOnEnterKey(e) {

        if (!saveConfigDisabled) {
            if (e.keyCode === 13) {
                handleSaveConfig(false);
            }
        }

    }


    async function handleSaveConfig(createNew) {
        try {
            if (!sendingConfiguration) {
                sendingConfiguration = true;

                let url = `${taskListConfigUrl}`;
                let payload = config;
                payload['task_list'] = taskList.id;
                payload['fieldValidations'] = null;
                payload['operations'] = [...availableOperations.filter(x => selectedOperations.includes(x.id))];
                payload['override_operations_to_update'] = [...selectedOverridesData, ...overridesSelectedForRemoval];
                await validateForm(schema, payload);
                let method;
                if (payload['id'] === null) {
                    method = 'POST';
                } else {
                    url = `${url}${payload['id']}/`;
                    method = 'PUT';
                }
                let response = await submit(url, method, payload);

                if (response['id']) {
                    if (method === 'POST') {
                        rows = [...rows, response];
                    } else {
                        await getConfigurations();
                    }

                    createNew? await handleCreateNew(): await handleSaveAndClose();
                } else {
                    errors = await response.json();
                    formErrors = errors;
                }

                sendingConfiguration = false;
            }
        } catch (err) {
            sendingConfiguration = false;
            resetFormValidation();
            if (Object.keys(err).length) {
                saveConfigFormErrors = err;
            } else {
                saveConfigFormErrors = null;
            }

            // validateForm failed
            if (err.inner) {
                err.inner.forEach((er) => {
                    fieldIsValid[er.path].isValid = false;
                    fieldIsValid[er.path].errors = er.message;
                });
            } else {
                // server rejected payload
                for (const [key, value] of Object.entries(err)) {
                    if (key in fieldIsValid) {
                        fieldIsValid[key].isValid = false;
                        fieldIsValid[key].errors = value;
                    }
                }
            }
        }

    }

    async function getConfigurations() {
        if (activityVersionId) {

            const response = await get(`${taskListConfigUrl}?activity_version=${activityVersionId}`);
            const json = await response.json();

            if (json) {
                rows = json['results'];
            }
        }
    }

    $: overrideColumns = {
        operation_id: {
            label: sgettext('$$SAP_OPERATION$$'),
            renderer: SelectColumn,
            width: '45%',
            props: {
                options: operationOptionsData,
                placeholder: ''
            }
        },
        override_operation: {
            label: sgettext('$$OVERRIDE_OPERATION$$'),
            renderer: TextColumn,
            width: '40%',
            props: {
            }
        }
    }

    const userDefinedOperationColumns = {
        number: {
            label: sgettext('$$OPERATION_NUMBER$$'),
            renderer: UserDefinedOperationColumn,
            width: '30%',
        }
    }

    async function handleOverrideRemove(item) {
        if (item.operation_id && item.existing) {
            overridesSelectedForRemoval = [...overridesSelectedForRemoval, {...item, expire: true}]
        }
        selectedOverrides = selectedOverridesData.filter(t => t.index !== item.index);
    }

    let overrideRowActions = {
        remove: {
            iconClass: 'fas fa5-trash-alt',
            handler: (event, item) => {
                handleOverrideRemove(item);
            }
        }
    }

    async function handleUserDefinedOperationsRemove(item) {
        item.deleted = true;
        userDefinedOperationsData = [...userDefinedOperationsData.filter(x => x.id !== item.id), item];
        clearFormErrors();
    }

    let userDefinedRowActions = {
        remove: {
            iconClass: 'fas fa5-trash-alt',
            handler: (event, item) => {
                handleUserDefinedOperationsRemove(item);
            }
        }
    }

    $: if (activityVersionId) {
        getConfigurations();
    }
</script>

{#if warnUnmappedSequences}
  <div class="alert alert-danger" role="alert">
    <b>{sgettext('$$OPERATION_MAPPING_COMPLETED$$')}</b> -
    {sgettext(
      '$$TEMPLATE_TASK_LIST_CONFIGURATION_PLEASE$$'
    )}
  </div>
{/if}

<Modal
  id={deleteModal}
  title={sgettext('$$DELETE_TASK_LIST$$')}
  backdrop={'static'}
>
  <div slot="body">
    <slot name="message">
      <p class="alert alert-danger">
        {sgettext('$$PLEASE_CONFIRM_DELETION_FOLLOWING_TASK$$')}
      </p>
      <p>
        {#if selectedItem}
          <p>{selectedItem.name}</p>
          <ul>
            {#each selectedItem.operations as operation}
              <li>
                {#if operation.user_defined}
                  <span class="text-info">{operation.number}</span>
                {:else}
                  {operation.number} - {operation.description} - {operation.resource_work_centre}
                {/if}
              </li>
            {/each}
          </ul>
        {/if}
      </p></slot
    >
  </div>
  <div class="footer" slot="footer">
    <Button
      type="outline"
      on:click={handleCancelDelete}
      name={sgettext('$$CANCEL$$')}
    />
    <Button
      type="primary"
      on:click={handleDeleteItem}
      name={sgettext('$$DELETE_1$$')}
      sending={deleting}
    />
  </div>
</Modal>

<Modal
  id={configModal}
  large={true}
  title={sgettext('$$CONFIGURE_TASK_LIST$$')}
  onCancel={handleCancelConfig}
  backdrop={'static'}
>
  <div slot="body">
    <slot name="message">
      <div class:d-none={!showSplitTaskListMessage} class="alert alert-info">
        {sgettext(
          "$$NOTE_DESELECTING_OPERATIONS_ENABLE_SPLIT$$"
        )}
      </div>

      <div>
        <p>
          <Errors errors={saveConfigFormErrors} />
        </p>
      </div>

      <div class="d-flex">
        <div class="mb-1 mr-1">
          <TextInput
            id="groupNumber"
            label={sgettext('$$GROUP_NUMBER$$')}
            bind:value={config.group}
            bind:isValid={fieldIsValid.group.isValid}
            bind:errors={fieldIsValid.group.errors}
            handleKeyPress={handleSearchOnEnterKey}
            {schema}
          />
        </div>

        <div class="mb-1 ml-1">
          <TextInput
            id="groupCounter"
            label={sgettext('$$GROUP_COUNTER$$')}
            bind:value={config.group_counter}
            bind:isValid={fieldIsValid.group_counter.isValid}
            bind:errors={fieldIsValid.group_counter.errors}
            handleKeyPress={handleSearchOnEnterKey}
            {schema}
          />
        </div>
        <div class="mb-1 ml-1 d-flex flex-column-reverse">
          <Button
            style="border-color: #dd5900; color: #dd5900; display: block; height: 44px"
            type="outline"
            on:click={handleSearchTaskList}
            name={sgettext('$$SEARCH$$')}
          >
            <div slot="text">
              {sgettext('$$SEARCH$$')}
              {#if sendingSearch} <i class="fa fa-spinner fa-spin" /> {/if}
            </div>
          </Button>
        </div>
      </div>

      <div class="mt-2 mb-3">
        <p>
          {searchStatus}
        </p>
      </div>

      {#if availableOperations.length > 0}
        <div class="mb-1">
          {#if taskList.description}
            <div>
              <label>
                {sgettext(
                  '$$SELECT_OPERATIONS_AVAILABLE_TASK_LIST$$'
                )}:
              </label>
              <p>{taskList.description}</p>
            </div>
          {/if}

          {#if !fieldIsValid.operations.isValid}
            <div class="pl-3 text-danger">{fieldIsValid.operations.errors}</div>
          {/if}

          <div class="pl-3">
            {#each availableOperations as operation}
              <div>
                <label
                  class:text-secondary={existingMappingsForAvailableOperationsInOtherActivities[
                    operation.id
                  ] !== undefined}
                >
                  <input
                    type="checkbox"
                    bind:group={selectedOperations}
                    name="operations"
                    disabled={existingMappingsForAvailableOperationsInOtherActivities[
                      operation.id
                    ] ||
                      existingMappingsForAvailableOperationsInOtherTaskListsForThisActivity[
                        operation.id
                      ]}
                    value={operation.id}
                  />

                  {#if operation.user_defined}
                    <span class="text-info" title={sgettext('$$USERDEFINED$$')}
                      ><i class="fas fa5-user-plus fa-fw" />
                      {operation.number}</span
                    >
                    - {sgettext('$$USER_DEFINED$$')}
                  {:else}
                    {operation.number} - {operation.description} - {operation.resource_work_centre}
                  {/if}

                  {#if existingMappingsForAvailableOperationsInOtherActivities[operation.id]}
                    <span class="pl-3 text-secondary"
                      >- {sgettext('$$MAPPED$$')}</span
                    >
                    <a
                      href={`${PATH_PREFIX}/sw/builder/activity_version/task_list_config/${existingMappingsForAvailableOperationsInOtherActivities[operation.id].activity_version.id}`}
                      target="_blank" rel="noopener noreferrer"
                    >
                      {existingMappingsForAvailableOperationsInOtherActivities[
                        operation.id
                      ].activity_version.name}
                    </a>
                  {/if}

                  {#if existingMappingsForAvailableOperationsInOtherTaskListsForThisActivity[operation.id]}
                    <span class="pl-3 text-secondary"
                      >- {sgettext('$$TL_CONFIG$$')}: {existingMappingsForAvailableOperationsInOtherTaskListsForThisActivity[
                        operation.id
                      ]?.configuration_name ||
                        sgettext('$$CONFIG_NAME_PROVIDED$$')}</span
                    >
                  {/if}
                </label>
              </div>
            {/each}
          </div>
        </div>

        <div class="mb-1 pl-3">
          <TextInput
            id="name"
            label={sgettext(
              '$$ENTER_DESCRIPTION_TASK_LIST$$'
            )}
            bind:value={config.name}
            bind:isValid={fieldIsValid.name.isValid}
            bind:errors={fieldIsValid.name.errors}
            handleKeyPress={handleSaveOnEnterKey}
            ignoreFieldLevelValidation={true}
            {schema}
          />
        </div>

        <br/>
        <br/>
      {/if}
    </slot>
  </div>

  <div class="footer" slot="footer">
    <Button
      type="outline"
      on:click={handleCancelConfig}
      name={sgettext('$$CANCEL$$')}
    />
    {#if showSaveAndNewButton}
      <Button
        type="primary"
        on:click={() => handleSaveConfig(true)}
        name={sgettext('$$SAVE_NEW_CONFIG$$')}
        disabled={saveConfigDisabled}
        sending={sendingConfiguration}
      >
        <div slot="text">
          {sgettext('$$SAVE_NEW_CONFIG$$')}
          {#if sendingConfiguration} <i class="fa fa-spinner fa-spin" /> {/if}
        </div>
      </Button>
    {/if}
    <Button
      type="primary"
      on:click={() => handleSaveConfig(false)}
      name={sgettext('$$SAVE$$')}
      disabled={saveConfigDisabled}
      sending={sendingConfiguration}
    >
      <div slot="text">
        {sgettext('$$SAVE$$')}
        {#if sendingConfiguration} <i class="fa fa-spinner fa-spin" /> {/if}
      </div>
    </Button>
  </div>
</Modal>

<Modal
  id={userDefinedOperationsModal}
  large={true}
  title={sgettext('$$USERDEFINED_OPERATIONS$$')}
  backdrop={'static'}
  onCancel={handleCancelUserDefinedOperations}
  onSave={userDefinedOperationsOnSaveAndClose}
>
  <div slot="body">
    <slot name="message">
      <div>
        <div class="mb-1">
          <strong>
            {sgettext('$$CONFIGURATION$$')}: ({config.group}, {config.group_counter})
            {config.name}
          </strong>
        </div>
        <div class="my-1">
          {sgettext(
            "$$USERDEFINED_OPERATIONS_NT_EXIST_TASK$$"
          )}:
        </div>
      </div>
      {#if userDefinedOperationsErrors}
        <div class="alert alert-danger" role="alert">

          {#if userDefinedOperationsErrors.message}
            <div>{userDefinedOperationsErrors.message}</div>
          {:else}
              <div>{userDefinedOperationsErrors}</div>
          {/if}
          {#if userDefinedOperationsErrors.links}
            <div>
              {sgettext(
                '$$REMOVE_OPERATION_SEQUENCE_MAPPINGS_USED$$'
              )}:
            </div>
            <ul>
              {#each userDefinedOperationsErrors.links as link}
                <li>
                  <a
                    href={`${PATH_PREFIX}/sw/builder/activity_version/task_list_config/${
                      link[0]
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link[1]}
                  </a>
                </li>
              {/each}
            </ul>
          {/if}
        </div>
      {/if}
      <div class="mt-2 mb-3">
        {#if userDefinedOperationsData.filter((x) => !x.deleted).length === 0}
          <div
            class="my-1 p-3 text-info"
            style="border: 1px solid lightgrey; background-color: #ffffff"
          >
            {sgettext('$$USERDEFINED_OPERATIONS_ADDED$$')}
          </div>
        {:else}
          <DataTable
            columns={userDefinedOperationColumns}
            rows={userDefinedOperationsData}
            rowActions={userDefinedRowActions}
            schema={userDefinedRowSchema}
            emptyLabel={sgettext('$$USERDEFINED_OPERATIONS_ADDED$$')}
            {sending}
          />
        {/if}
      </div>

      <div class="form-group mt-1">
        <div class="actions d-flex flex-nowrap justify-content-end">
          <button
            class="btn btn-outline-primary"
            role="button"
            on:click={handleCreateNewUserDefinedOperation}
          >
            {sgettext('$$ADD_NEW$$')}
          </button>
        </div>
      </div>
    </slot>
  </div>
</Modal>

<div class="wrapper">
  <div class="actions d-flex flex-nowrap justify-content-between mb-3">
    <div class="d-inline-block">
      <h2>
        {sgettext('$$SAP_TASK_LIST_CONFIGURATION$$')}
        {#if planningPlant !== ''} - {planningPlant} {/if}
        {#if timeZone}
          ({timeZone})
        {:else}
          {sgettext('$$TIMEZONE_SET$$')}
        {/if}
      </h2>
    </div>

    {#if template}
      <button class="btn btn-primary" role="button" on:click={handleCreateNew}>
        <i class="fa fa-plus" />
        {sgettext('$$ADD_CONFIGURATION$$')}
      </button>
    {/if}
  </div>

  <TaskListConfigurationDataTable
    {columns}
    rows={data}
    {rowActions}
    {schema}
    {saving}
    {bgColor}
  />
  <Errors {errors} />
</div>

<Modal
  id={overrideModal}
  title={sgettext('$$OPERATION_OVERRIDES$$')}
  backdrop={'static'}
  large={true}
  onCancel={handleCancelOverride}
  onSave={overrideOnSaveAndClose}
>
  <div slot="body">
    <slot name="message">
      <p class="alert alert-info">
        {sgettext(
          '$$NOTE_OPERATION_OVERRIDE_APPLIED_MAPPED$$'
        )}
      </p>
      <Errors errors={formErrors} />
      <DataTable
        columns={overrideColumns}
        rows={selectedOverridesData}
        rowActions={overrideRowActions}
        schema={rowSchema}
        emptyLabel={sgettext('$$OPERATION_OVERRIDES_CONFIGURED$$')}
        {sending}
      />
      {#if selectedOverridesData.length < operationOptionsData.length}
        <div class="form-group mt-1">
          <div class="actions d-flex flex-nowrap justify-content-end">
            <button
              class="btn btn-outline-primary"
              role="button"
              on:click={handleCreateNewOverride}
            >
              {sgettext('$$ADD_NEW_OPERATION_OVERRIDE$$')}
            </button>
          </div>
        </div>
      {/if}
    </slot>
  </div>
</Modal>

<style>
  .wrapper {
    margin-bottom: 15px;
  }

  .actions {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
  }

  tbody tr:first-child td {
    border-top: none !important;
  }
</style>
